import * as r from "react";
import { ComponentClassNames as e } from "../shared/constants.js";
import "tslib";
import "classnames";
import "../View/View.js";
import { IconCheckCircle as n } from "../Icon/icons/IconCheckCircle.js";
import { IconError as o } from "../Icon/icons/IconError.js";
import { IconInfo as a } from "../Icon/icons/IconInfo.js";
import { IconWarning as c } from "../Icon/icons/IconWarning.js";

var s = function s(_ref) {
  var s = _ref.variation,
      t = _ref.ariaHidden;

  switch (s) {
    case "info":
      return r.createElement(a, {
        "aria-hidden": t,
        className: e.AlertIcon
      });

    case "error":
      return r.createElement(o, {
        "aria-hidden": t,
        className: e.AlertIcon
      });

    case "warning":
      return r.createElement(c, {
        "aria-hidden": t,
        className: e.AlertIcon
      });

    case "success":
      return r.createElement(n, {
        "aria-hidden": t,
        className: e.AlertIcon
      });

    default:
      return null;
  }
};

s.displayName = "AlertIcon";
export { s as AlertIcon };